import React from 'react'
import { CircleLoading } from '../../Assets/Icons';


const BtnLoad = () => {
    return (
        <div className="loading-button">
            <CircleLoading />
        </div>
    );
};

export default BtnLoad;